document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("submit", function (e) {
        var btn = e.submitter;
        if (!btn) return;

        if (btn.dataset.confirm) {
            e.preventDefault();
            showConfirmDialog(btn.dataset.confirm, function () {
                var msg = btn.dataset.confirm;
                delete btn.dataset.confirm;
                btn.closest("form").requestSubmit(btn);
                btn.dataset.confirm = msg;
                showButtonLoading(btn);
            });
        } else if (!btn.hasAttribute("data-no-spinner")) {
            showButtonLoading(btn);
        }
    });

    window.addEventListener("pageshow", function (e) {
        if (e.persisted) {
            document.querySelectorAll("button[data-spinner-active]").forEach(function (btn) {
                restoreButton(btn);
            });
        }
    });

    function showConfirmDialog(message, onConfirm) {
        var overlay = document.createElement("div");
        overlay.className = "fixed left-0 top-0 z-50 flex h-full min-h-screen w-full items-center justify-center bg-black/90 transition-opacity duration-150 opacity-0";

        overlay.innerHTML =
            '<div class="relative w-full max-w-lg rounded-lg bg-background px-6 py-5" role="dialog" aria-modal="true">' +
            '<h3 class="pb-2 text-lg font-bold">Confirm</h3>' +
            '<span class="block mb-4 h-1 w-full rounded bg-warning"></span>' +
            '<p class="mb-6">' + escapeHtml(message) + '</p>' +
            '<div class="flex justify-end space-x-2">' +
            '<button type="button" class="confirm-btn text-sm py-2 px-4 rounded-md bg-danger text-danger-foreground hover:bg-danger-darken duration-150">Confirm</button>' +
            '<button type="button" class="cancel-btn text-sm py-2 px-4 rounded-md border border-stroke hover:bg-muted duration-150">Cancel</button>' +
            '</div>' +
            '</div>';

        document.body.appendChild(overlay);

        requestAnimationFrame(function () {
            overlay.classList.remove("opacity-0");
            overlay.classList.add("opacity-100");
        });

        function close() {
            overlay.classList.remove("opacity-100");
            overlay.classList.add("opacity-0");
            setTimeout(function () {
                overlay.remove();
            }, 150);
        }

        overlay.querySelector(".confirm-btn").addEventListener("click", function () {
            close();
            onConfirm();
        });

        overlay.querySelector(".cancel-btn").addEventListener("click", close);

        overlay.addEventListener("click", function (ev) {
            if (ev.target === overlay) close();
        });

        function onKey(ev) {
            if (ev.key === "Escape") {
                close();
                document.removeEventListener("keydown", onKey);
            }
        }

        document.addEventListener("keydown", onKey);
    }

    function showButtonLoading(btn) {
        if (btn.hasAttribute("data-spinner-active")) return;

        btn.setAttribute("data-spinner-active", "");
        btn.dataset.originalHtml = btn.innerHTML;
        btn.classList.add("cursor-not-allowed", "pointer-events-none", "opacity-60");

        var spinner = document.createElement("span");
        spinner.className = "btn-spinner";
        spinner.innerHTML =
            '<svg class="animate-spin w-4 h-4 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">' +
            '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>' +
            '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>' +
            '</svg>';

        btn.insertBefore(spinner, btn.firstChild);
    }

    function restoreButton(btn) {
        if (!btn.hasAttribute("data-spinner-active")) return;

        btn.removeAttribute("data-spinner-active");
        btn.innerHTML = btn.dataset.originalHtml;
        delete btn.dataset.originalHtml;
        btn.classList.remove("cursor-not-allowed", "pointer-events-none", "opacity-60");
    }

    function escapeHtml(str) {
        var div = document.createElement("div");
        div.textContent = str;
        return div.innerHTML;
    }
});
